import { request } from './request';
import { clearToken, setToken } from '../helpers/localstorage';

export const login = async ({ email, password }) => {
  const response = await request(
    'auth/login',
    {
      method: 'POST',
      body: { email, password },
    },
    false,
  );

  if (response.statusCode === 401 || !response.authToken) {
    return { error: { message: 'Incorrect email or password.' } };
  }

  setToken(response.authToken);

  return { user: response.user };
};

export const logout = async () => {
  clearToken();
};

export const sendResetPasswordEmail = async ({ email }) => {
  const response = await request(
    `auth/email/forgot-password/${email}`,
    { method: 'GET' },
    'Check your inbox for instructions.',
  );

  return response;
};

export const changePassword = async ({ token, password }) => {
  const response = await request(
    'auth/email/reset-password',
    {
      method: 'POST',
      body: { token, password },
    },
    'Password changed successfully!',
    false,
  );

  if (response.statusCode === 401 || !response.authToken) {
    return { error: { message: 'Incorrect token or password.' } };
  }

  setToken(response.authToken);

  return { user: response.user };
};
